import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider, useI18n } from "@/context/LanguageContext";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Countdown } from "@/components/Countdown";
import { Albums } from "@/components/Albums";
import { MarqueeBand } from "@/components/MarqueeBand";
import { Story } from "@/components/Story";
import { KeyInfo } from "@/components/KeyInfo";
import { Hotels } from "@/components/Hotels";
import { Schedule } from "@/components/Schedule";
import { DressCodeKidLess } from "@/components/DressCodeKidLess";
import { Gift } from "@/components/Gift";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { RegalPage } from "@/pages/RegalPage";

const SiteContent = () => {
  const { content, t } = useI18n();
  return (
    <div className="App grain" data-testid="wedding-app">
      <Nav />
      <Hero />
      <MarqueeBand text={t.marquee1} />
      <Countdown date={content.date} />
      <Albums />
      <Story />
      <MarqueeBand text={t.marquee2} reverse accent />
      <KeyInfo />
      <Schedule />
      <DressCodeKidLess />
      <Hotels />
      <Gift />
      <FinalCTA />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SiteContent />} />
          <Route path="/regal" element={<RegalPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
